import { IFooterViewModel } from 'Types/Litium';
import NewsletterSignup from 'Blocks/NewsletterSignup';
import Divider from 'Components/Divider';
import ListSection from 'Components/Footer/ListSection';
import PartnerSection from 'Components/Footer/PartnerSection';
import SocialSection from 'Components/Footer/SocialSection';
import Markup from 'Components/Markup';

const Footer = ({
    listSection,
    socialSection,
    partnerSection,
    additionalFooterInformation,
    newsletterBackgroundImage,
    newsletterHeader,
    newsletterConfirmationText,
    newsletterSignupEmailLabel,
    newsletterSubmitText,
    newsletterTermsAndConditionText,
    newsletterInputFields,
}: IFooterViewModel) => (
    <footer id="footer" className="flex flex-col bg-merino">
        {newsletterSubmitText && (
            <div className="pt-6 lg:pt-10">
                <NewsletterSignup
                    backgroundImage={newsletterBackgroundImage}
                    inputFields={newsletterInputFields}
                    confirmationText={newsletterConfirmationText}
                    termsAndConditionText={newsletterTermsAndConditionText}
                    submitText={newsletterSubmitText}
                    header={newsletterHeader}
                    emailLabel={newsletterSignupEmailLabel}
                />
            </div>
        )}
        <ListSection listSection={listSection} />
        <SocialSection socialSection={socialSection} />
        <div className="flex h-full w-full flex-col items-center justify-center">
            <Divider />
            {additionalFooterInformation?.value && (
                <Markup
                    html={additionalFooterInformation.value}
                    cssClass="w-full max-w-none py-3 px-4.5 mb-0"
                />
            )}
        </div>
        <Divider />
        <PartnerSection partnerSection={partnerSection} />
    </footer>
);

export default Footer;
